import { Permission, Permissions } from '@modules/auth/lib/permission.shared';

export const AdminPermissions = Permissions({
    database: Permission({
        key: 'admin:database',
        label: 'Open pgweb',
        category: 'Admin',
        description: 'Access the embedded pgweb database explorer.',
    }),
    permissions: Permission({
        key: 'admin:permissions',
        label: 'Read permission catalogue',
        category: 'Admin',
        description: 'Read the list of permission keys declared by every module.',
    }),
    roles: Permission({
        key: 'admin:roles',
        label: 'Manage roles',
        category: 'Admin',
        description: 'Create, update, delete roles and their permission lists.',
    }),
    users: Permission({
        key: 'admin:users',
        label: 'Manage users',
        category: 'Admin',
        description: 'List users, assign roles, set direct permission overrides.',
    }),
});
